import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {AccountSummaryRepository} from '@/profile-creation-wizard/components/for-completion/domain/AccountSummaryRepository';

export class AccountSummaryRepositoryAPI implements AccountSummaryRepository {
    async uploadPhoto(file: File) {
        const fd = new FormData();
        fd.append('file', file);
        const [data, error] = await context.httpService.post(context.registry.entries.photo(), fd);
        return [data, error];
    }
}
